import VueSounds from "vue-sounds/utils/index";

const soundPluginImpl = {
    install(Vue, storeSounds, options) {
        const instanceSounds = new VueSounds(storeSounds, options);
        Vue.prototype.$sound = {
            play: function (soundName = "success", volume = 0.9) {
                if (!storeSounds.state.control.activeSound) return;
                const sound = instanceSounds.get(soundName);
                sound.volume(volume);
                sound.play();
            }
        };
    }
};

export default soundPluginImpl;
